import {
  concat, findIndex, insert, merge, propEq, reject
} from 'ramda';
import { sortArrayByObjectsPropertyValues } from 'src/utils/arrays';
import {
  SUCCESS, FAIL, REQUEST,
  SUBMIT_SUCCESS, SUBMIT_FAIL, SUBMIT_REQUEST,
  DELETE_FAIL, DELETE_REQUEST, DELETE_SUCCESS,
  UPDATE_FAIL, UPDATE_SUCCESS, UPDATE_REQUEST
} from 'src/store/actions/workShiftsActions';

const initialState = {
  list: [],
  options: [],
  fetching: false,
  errors: []
};

const reformatWorkShiftsOptionsMenu = (data) => data.map((workShifts) => ({
  value: workShifts.Id.toString(),
  label: workShifts.Name
}));

const replaceInList = (shift, list) => insert(findIndex(propEq('Id', shift.Id), list), shift, reject(propEq('Id', shift.Id), list));

const replaceInOptions = (shift, options) => {
  const [option] = reformatWorkShiftsOptionsMenu([shift]);
  return insert(findIndex(propEq('value', option.value), options), option, reject(propEq('value', option.value), options));
};

const workShiftsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, {
        list: sortArrayByObjectsPropertyValues(action.workShifts, 'Name'),
        options: sortArrayByObjectsPropertyValues(reformatWorkShiftsOptionsMenu(action.workShifts), 'label'),
        fetching: false,
        errors: []
      });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case SUBMIT_REQUEST:
      return merge(state, { fetching: true });
    case SUBMIT_SUCCESS:
      return merge(state, {
        list: sortArrayByObjectsPropertyValues(concat(state.list, [action.workShift]), 'Name'),
        options: sortArrayByObjectsPropertyValues(
          concat(state.options, reformatWorkShiftsOptionsMenu([action.workShift])),
          'label'
        ),
        fetching: false,
        errors: []
      });
    case SUBMIT_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('Id', action.workShift), state.list),
        options: reject(propEq('value', action.workShift.toString()), state.options)
      });
    case UPDATE_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case UPDATE_SUCCESS:
      return merge(state, {
        list: sortArrayByObjectsPropertyValues(replaceInList(action.workShift, state.list), 'Name'),
        options: sortArrayByObjectsPropertyValues(replaceInOptions(action.workShift, state.options), 'label'),
        fetching: false,
        errors: []
      });
    case UPDATE_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default workShiftsReducer;
